import React from "react";
import {
    Container,
    Row,
} from 'reactstrap';

import DataProvider from '../services/DataProvider'

const Relatorios = () => {

    const [relatorioImg, setRelatorioImg] = React.useState([])

    React.useEffect(() => {
        DataProvider.getAll('WsSanEndPoints.rule?sys=SAS').then((response) => {
            if(response.data.arquivos)
            if (typeof response.data.arquivos.filter === 'function') {
                setRelatorioImg(response.data.arquivos.filter((v) => v.IMG_TIPO === 'R'))

            }
        })
       
    }, []);


    return <Container className="mt-5 mb-4">
        <h1 className="nopadding color-primary mt-3">Relatórios</h1>
        <Row className="px-2 mt-4 text-center mb-3">

            {relatorioImg.map((v, i) => {
                return (
                    <div className="relatorio-envelope">
                        <div className="col-md mb-2 mt-2" key={i}>
                                <div className="relatorio-envelope-column">
                                    <div className="card-relatorio" >
                                        <a href={v.IMG_CAMINHO_PDF} target='_blank' style={{ display: 'block' }} >
                                            <img src={v.IMG_CAMINHO} alt={v.IMG_NOME_IMAGEM} style={{width: 195,height: 278}}/>
                                        </a>
                                    </div>
                                </div>
                                <div className="relatorio-envelope-column">
                                    <p className="mb-1 mt-1" >{v.IMG_TITULO}</p>
                                    <b >{v.IMG_DESCRICAO}</b>
                                </div>
                        </div>
                    </div>
                )
            })}

        </Row>
    </Container>
}

export default Relatorios;